import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { store as mainStore } from '../../../../../../store';
import axios from '../../../../../../api/axios';
import Progressbar from '@material-ui/core/LinearProgress';
import Avatar from '../../../../../../components/User/UserAvatar';
import DriverPlate from '../../../../../../components/User/DriverPlate';
import UserRank from '../../../../../../components/User/UserRank';
import Button from '@material-ui/core/Button';
import SendSMSDialog from './SendSMSDialog';
import formatNumber from '../../../../../../fns/formatNumber';
import Typography from '@material-ui/core/Typography';

const useStyels = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(1),
    display: 'flex',
    flexFlow: 'row wrap',
    '&>div:not(:last-child)': {
      marginRight: theme.spacing(1),
    },
    '& > div.item': {
      width: 250,
      padding: theme.spacing(1),
      background: '#9ccc65',
      display: 'flex',
      flexFlow: 'column nowrap',
      '& > *': {
        marginBottom: theme.spacing(1),
      },
      '& > span': {
        fontWeight: 'bold',
        marginRight: theme.spacing(1),
      },
    },
  },
  noConfirmedDriver: {
    width: '100%',
  },
}));

const Drivers = ({ order }) => {
  const classes = useStyels();
  const { showMessage, showError } = useContext(mainStore);
  const [state, setState] = useState({
    loading: true,
    drivers: null,
    selectedDriver: false,
  });
  const { loading, drivers, selectedDriver } = state;
  const handleCloseDialog = () => {
    setState({ ...state, selectedDriver: false });
  };
  const handleSelectDriver = (driver) => {
    setState({ ...state, selectedDriver: driver });
  };
  const handleShowReceipt = async (mediaId) => {
    try {
      showMessage('در حال دانلود تصویر رسید ...');
      const { data } = await axios.get(`/api/v1/admin/media/${mediaId}/image`);
      data?.ok && window.open(data?.image, '_blank');
    } catch (error) {
      showError(error);
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const {
          data: { drivers, bidders },
        } = await axios.get(`/api/v1/admin/orders/${order._id}/drivers`);
        const _drivers = drivers.map((driver) => {
          const bid = bidders.find((bid) => bid.driver._id === driver._id);
          return { ...driver, propose: bid?.propose || 0 };
        });
        setState({ ...state, drivers: _drivers, loading: false });
      } catch (error) {
        showError(error);
      }
    })();
  }, [order]);

  return (
    <div className={classes.root}>
      {loading ? <Progressbar /> : null}
      {drivers?.length ? (
        drivers.map((driver) => (
          <div key={driver._id} className="item">
            <Avatar user={driver.user} fullName />
            {driver.numberPlate ? <DriverPlate driver={driver} /> : null}
            <div>
              <span>ناوگان:</span>
              {`${driver?.fleetOptions?.[0]?.fleet?.title}(${driver?.fleetOptions?.[0]?.title})`}
            </div>
            {/* <UserRank user={driver.user} /> */}
            <Button
              variant="contained"
              color="secondary"
              fullWidth
              onClick={() => handleSelectDriver(driver)}
            >
              ارسال مشخصات راننده
            </Button>
            {driver?.propose ? (
              <>
                <div>پیشنهاد حمل بار راننده:</div>
                <Typography component="span" varaint="h2">
                  {formatNumber(driver.propose) + ' تومان'}
                </Typography>
              </>
            ) : null}
            {order?.readyWaybills?.includes(driver._id) && (
              <div>بارنامه صادر شد.</div>
            )}
            {order?.readyForTransporting?.includes(driver._id) && (
              <div>بارگیری انجام شده است.</div>
            )}
            {order?.deliveredDrivers?.includes(driver._id) && (
              <div>بار را تحویل داده است.</div>
            )}
            {order?.deliveryReceipts?.some(
              (receipt) => receipt?.driver === driver?._id
            ) ? (
              <Button
                variant="contained"
                onClick={() =>
                  handleShowReceipt(
                    order?.deliveryReceipts?.find(
                      (receipt) => receipt?.driver === driver?._id
                    )['media']
                  )
                }
              >
                مشاهده رسید تحویل بار
              </Button>
            ) : null}
            <SendSMSDialog
              driver={selectedDriver}
              onClose={handleCloseDialog}
              order={order}
            />
          </div>
        ))
      ) : (
        <div className={classes.noConfirmedDriver}>
          هنوز راننده ای برای این سفارش انتخاب نشده است.
        </div>
      )}
    </div>
  );
};

export default React.memo(Drivers);
